import { render, staticRenderFns } from "./PostNews.vue?vue&type=template&id=606fd10e&scoped=true&"
import script from "./PostNews.vue?vue&type=script&lang=js&"
export * from "./PostNews.vue?vue&type=script&lang=js&"
import style0 from "./PostNews.vue?vue&type=style&index=0&id=606fd10e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606fd10e",
  null
  
)

export default component.exports